import { render, staticRenderFns } from "./SalesPagesContainer.vue?vue&type=template&id=7f4f6755&"
import script from "./SalesPagesContainer.vue?vue&type=script&lang=js&"
export * from "./SalesPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports